import type { RouteObject } from 'react-router-dom';
import { Routes } from '@/routes/routes';

export const usersRoutes: RouteObject[] = [
	{ path: Routes.USERS_ROOT, element: <></> },
	{ path: Routes.USERS_PROFILE, element: <></> },
];
